import React, { useState } from "react";
import PropTypes from 'prop-types';

export const Search = ({ onSearch }) => {
  const [query, setQuery] = useState("");

  const handleSearch = (e) => {
    const value = e.target.value;
    setQuery(value);
    if (typeof onSearch === 'function') {
      onSearch(value);
    }
  };

  return (
    <input
      type="text"
      value={query}
      onChange={handleSearch}
      placeholder="Search by ID, Name, or Description..."
      className="w-full px-4 py-2 border border-gray-300 rounded-md 
                focus:outline-none focus:ring-2 focus:ring-blue-500 
                text-gray-900 bg-white placeholder-gray-500"
    />
  );
};

Search.propTypes = {
  onSearch: PropTypes.func.isRequired
};

export default Search;